<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="批次：" prop="batch">
                <el-input v-model="model.batch"></el-input>
            </el-form-item>
            <el-form-item label="省份：" prop="province">
                <el-input v-model="model.province"></el-input>
            </el-form-item>
            <el-form-item label="城市：" prop="city">
                <el-input v-model="model.city"></el-input>
            </el-form-item>
            <el-form-item label="RN码：" prop="rn">
                <el-input v-model="model.rn"></el-input>
            </el-form-item>
            <el-form-item label="创建时间：" prop="order_time">
                <el-input v-model="model.order_time"></el-input>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <el-input v-model="model.update_time"></el-input>
            </el-form-item>
            <el-form-item label="交付时间：" prop="deliver_time">
                <el-input v-model="model.deliver_time"></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <el-input v-model="model.model"></el-input>
            </el-form-item>
            <el-form-item label="版本：" prop="banben">
                <el-input v-model="model.banben"></el-input>
            </el-form-item>
            <el-form-item label="颜色：" prop="yanse">
                <el-input v-model="model.yanse"></el-input>
            </el-form-item>
            <el-form-item label="轮毂：" prop="lungu">
                <el-input v-model="model.lungu"></el-input>
            </el-form-item>
            <el-form-item label="内饰：" prop="neishi">
                <el-input v-model="model.neishi"></el-input>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <el-input v-model="model.add_time"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deliveryEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                batch: '',
                province: '',
                city: '',
                rn: '',
                order_time: '',
                update_time: '',
                deliver_time: '',
                model: '',
                banben: '',
                yanse: '',
                lungu: '',
                neishi: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/delivery/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/delivery/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>